import { useMemo } from 'react';

/**
 * Simple hook to detect if the current form is rendered in hosted page context
 *
 * Detection methods:
 * 1. URL path contains /donate/ or /attend/ (production/staging)
 * 2. Running on localhost:3002 (local development - hosted-page dev server)
 * 3. URL has ?attend or ?donate query param (custom domain hosted pages,
 *    e.g., testsite.charitystack.com/ali?attend&formid=...)
 *
 * @returns {boolean} true if in hosted page, false if embedded
 */
export const useIsHostedPage = () => {
  return useMemo(() => {
    const currentPath = window.location.pathname;
    const hostname = window.location.hostname;
    const port = window.location.port;

    // Check URL path patterns (production/staging)
    const hasHostedPath = currentPath.includes('/donate/') || currentPath.includes('/attend/');

    // Check if running on localhost:3002 (local development for hosted-page)
    const isLocalHostedDev = (hostname === 'localhost' || hostname === '127.0.0.1') && port === '3002';

    // Check for custom domain hosted pages (e.g., testsite.charitystack.com/ali?attend&formid=...)
    // ?attend = event form, ?donate = fundraiser form on custom domains
    const urlParams = new URLSearchParams(window.location.search);
    const hasHostedQueryParam =
      (urlParams.has('attend') || urlParams.has('donate')) && urlParams.has('formid');

    return hasHostedPath || isLocalHostedDev || hasHostedQueryParam;
  }, []);
};

export default useIsHostedPage;
